import template from './refineTasks.html';

function refineTasks() {
  return {
    restrict: 'E',
    template
  };
}

export default function (ngModule) {
  ngModule.directive('refineTasks', refineTasks);
}
